require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flyout"), require("./menu"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flyout", "./menu"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flyout"), require("./menu")) : factory(root["./utils"], root["./flyout"], root["./menu"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__38__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[17],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-context-menu.ba-common-flyout__container{width:200px}.ba-common-context-menu .ba-common-separator{margin:0px;border-color:#e0e0e0}.ba-common-context-menu__wrapper{max-height:480px;overflow:auto}.ba-common-context-menu__wrapper .ba-common-context-menu__icon{display:flex;margin-right:8px}.ba-common-context-menu__wrapper .ba-common-context-menu__item{padding:0 16px 0 12px;font-size:.875rem;height:40px;display:flex;align-items:center;cursor:pointer;border-left-width:4px}.ba-common-context-menu__wrapper .ba-common-context-menu__item .ba-common-toolTip{width:100%}.ba-common-context-menu__wrapper .ba-common-context-menu__item--text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ba-common-context-menu__wrapper .ba-common-context-menu__item--text .cursor{cursor:pointer}.ba-common-context-menu .ba-common-toggleSwitch{margin:8px 0}.ba-common-context-menu .ba-common-toggleSwitch.is-small{margin:12px 0}", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-context-menu\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(278);


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ContextMenu = _interopRequireDefault(__webpack_require__(279));

exports.default = _ContextMenu.default;
exports.ContextMenu = _ContextMenu.default;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _flyout = __webpack_require__(25);

var _utils = __webpack_require__(5);

var _menu = _interopRequireDefault(__webpack_require__(38));

var _ContextMenu = _interopRequireDefault(__webpack_require__(280));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const contextMenuClassName = _ContextMenu.default.menuClassName.replace(/"/g, '');

let candidatePlacement = ['left', 'top', 'bottom', 'right', 'topLeft', 'bottomLeft', 'topRight', 'bottomRight'];
const {
  sanitize
} = _utils.propsUtils;
/** The Context menu is built on top of `<Flyout>`, inheriting much functionality from it.  As such, some of the same properties are made available to context menu as well. */

class ContextMenu extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_onChange", (name, item, isDisabled) => {
      const {
        onChange
      } = this.props;
      onChange && onChange(name, item, isDisabled);
    });
  }

  static Spacer(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Spacer, props);
  }

  static Separator(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Separator, props);
  }

  static List(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.List, props);
  }

  static Radio(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Radio, props);
  }

  static Checkbox(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Checkbox, props);
  }

  static ToggleSwitch(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.ToggleSwitch, props);
  }

  static Accordion(props) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Accordion, props);
  }

  render() {
    const {
      align,
      triggerNode,
      theme,
      onClose,
      fixedPosition,
      domNodeToAttachTo,
      className,
      children,
      selected,
      menuExtraOptions,
      startingFocusIndex,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(contextMenuClassName);
    let {
      placement,
      style
    } = this.props;
    let alignStyles = {};

    if (triggerNode && align && (align === 'left' || align === 'right')) {
      const bodyRect = document.body.getBoundingClientRect();
      const contextRect = triggerNode.getBoundingClientRect();
      const offsetTop = Math.abs(bodyRect.top - contextRect.top) + contextRect.height;
      const offsetRight = Math.abs(bodyRect.right - contextRect.right);

      switch (align) {
        case 'left':
          candidatePlacement = [];
          placement = 'bottomRight';
          alignStyles = {
            left: contextRect.left,
            top: offsetTop
          };
          break;

        case 'right':
          candidatePlacement = [];
          placement = 'bottomLeft';
          alignStyles = {
            right: offsetRight,
            left: null,
            top: offsetTop
          };
          break;

        default:
          break;
      }
    }

    style = { ...alignStyles,
      width: 'auto',
      minWidth: '200px',
      ...style
    };
    const flyoutProps = { ...sanitize(others, ContextMenu),
      placement,
      hideArrow: true,
      className: `${classNames} ${className}`,
      offset: 8,
      // 8 pixel distance for the context menu defined by design
      fixedPosition,
      triggerNode,
      onClose,
      domNodeToAttachTo,
      style,
      candidatePlacement,
      startingFocusIndex
    };
    const menuClassName = (0, _utils.classnames)({
      contextMenu: true
    });
    const menuProps = {
      'data-tid': 'ba-common-contextmenu__menu',
      ...sanitize(menuExtraOptions, ContextMenu),
      className: menuClassName,
      selected,
      onChange: this._onChange
    };

    const menu = /*#__PURE__*/_react.default.createElement(_menu.default, menuProps, children);

    const contextFlyout = /*#__PURE__*/_react.default.createElement(_flyout.ContextFlyout, (0, _extends2.default)({}, flyoutProps, {
      ref: node => {
        this._contextMenu = node;
      }
    }), menu);

    const normalFlyout = /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, flyoutProps, {
      ref: node => {
        this._contextMenu = node;
      }
    }), menu);

    return theme ? contextFlyout : normalFlyout;
  }

}

exports.default = ContextMenu;
(0, _defineProperty2.default)(ContextMenu, "propTypes", {
  /** Where the Context Menu will be positioned visually off of the triggerNode. customPropTypes: ['top', 'bottom', 'left', 'right'] */
  placement: _propTypes.default.oneOfType([(props, propName, componentName) => {
    const value = props[propName];

    switch (value) {
      case 'left':
        console.error(new Error(`'${value}' supplied to '${propName}' in '${componentName}' is deprecated. It will be removed in Sprint 39.1, use 'topLeft' or 'bottomLeft' instead`)); // eslint-disable-line no-console

        break;

      case 'right':
        console.error(new Error(`'${value}' supplied to '${propName}' in '${componentName}' is deprecated. It will be removed in Sprint 39.1, use 'bottomRight' or 'topRight' instead`)); // eslint-disable-line no-console

        break;

      case 'top':
        console.error(new Error(`'${value}' supplied to '${propName}' in '${componentName}' is deprecated. It will be removed in Sprint 39.1, use 'topLeft' or 'topRight' instead`)); // eslint-disable-line no-console

        break;

      case 'bottom':
        console.error(new Error(`'${value}' supplied to '${propName}' in '${componentName}' is deprecated. It will be removed in Sprint 39.1, use 'bottomLeft' or 'bottomRight' instead`)); // eslint-disable-line no-console

        break;

      default:
    }

    return null;
  }, _propTypes.default.oneOf(candidatePlacement)]),

  /** Node that the Context Menu will visually position itself off of */
  triggerNode: _propTypes.default.instanceOf(Element),

  /** DOM node that the Context Menu will be attached to in the DOM */
  domNodeToAttachTo: _propTypes.default.instanceOf(Element),

  /** Function that is called when a value in the Context Menu changes (name and value are arguments) */
  onChange: _propTypes.default.func,

  /** Option to use context to grab the toolkit theme */
  theme: _propTypes.default.bool,

  /** Function to be called when a click outside of the Context Menu or triggerNode occurs */
  onClose: _propTypes.default.func,

  /** Class name to be given to the container of Context Menu */
  className: _propTypes.default.string,

  /** Object that defines which items from each sub-component are selected */
  selected: _propTypes.default.object,

  /** Sub-components of Context Menu to display (i.e. ContextMenu.List, ContextMenu.Radio, etc.) */
  children: _propTypes.default.node,

  /** Custom css styles */
  style: _propTypes.default.object,

  /** Extra options for the menu */
  menuExtraOptions: _propTypes.default.object,

  /** left/right aligns the context menu to the trigger node */
  align: _propTypes.default.oneOf(['left', 'right']),

  /** Flyout.propTypes.fixedPosition */
  fixedPosition: _flyout.Flyout.propTypes.fixedPosition,

  /** Focus index for flyout */
  startingFocusIndex: _propTypes.default.number
});
(0, _defineProperty2.default)(ContextMenu, "defaultProps", {
  placement: 'bottomRight',
  className: '',
  style: {},
  menuExtraOptions: {},
  startingFocusIndex: 0
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ContextMenu_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ContextMenu_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ContextMenu_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ContextMenu_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ContextMenu_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__38__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[277,0]]]);
});